"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    root: {
        height: 240,
        flexGrow: 1,
        maxWidth: 400,
        fontSize: "12",
    },
    content: {
        flexDirection: "row-reverse"
    },
    labelRoot: {
        display: "flex",
        alignItems: "center",
        padding: "7.5px"
    },
    labelIcon: {
        marginRight: "10px"
    },
    labelText: {
        fontFamily: 'HelveticaNeueCyr-Medium, Helvetica, sans-serif',
        fontWeight: 500,
        flexGrow: 1,
        fontSize: '14px',
        textTransform: 'capitalize',
    },
    childLabelText: {
        fontFamily: 'HelveticaNeueCyr-Roman, Helvetica, sans-serif',
        fontWeight: 400,
        flexGrow: 1,
        fontSize: '14px',
        textTransform: 'capitalize'
    },
    labelContainer: {
        display: 'inline-flex',
        alignItems: 'center'
    },
    checkbox: {
        color: '#DFDFE6',
        borderRadius: 4,
        padding: '7.5px 10px 7.5px 0'
    },
    checkedIcon: {
        backgroundColor: '#2EA0DC',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        borderRadius: 4,
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
    },
    checkedParentPart: {
        backgroundColor: '#ffffff',
        border: 'none',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            color: '#333333',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='2' viewBox='0 0 12 2'%3E%3Cg id='Group_673' data-name='Group 673' transform='translate(-375.33 -440)'%3E%3Crect id='Rectangle_266' data-name='Rectangle 266' width='2' height='12' rx='1' transform='translate(387.33 440) rotate(90)' fill='%23333'/%3E%3C/g%3E%3C/svg%3E%0A")`,
            content: '""',
        },
    }
};
